import './ImportacaoQuadroVendedores.css';
import { useRef, useState } from 'react';
import { post } from '../../services/api';
import AdminSection from "../AdminSection/AdminSection";
import DownloadIcon from '@mui/icons-material/Download';
import { TailSpin } from "react-loader-spinner";
import Select from 'react-select';

export default function ImportacaoQuadroVendedores({ setNotifier }) {

    const [valorBaseCSVFileName, setValorBaseCSVFileName] = useState(undefined);
    const [file, setFile] = useState(null);
    const inputRef = useRef(null);
    const [isFetchingDataImportacao, setIsFetchingDataImportacao] = useState(false);
    const [disabledImportacao, setDisabledImportacao] = useState(true);
    const [mesAnoImportacao, setMesAnoImportacao] = useState(false);

    async function importarQuadroReal() {
        try {

            let mes, ano;
            [mes, ano] = mesAnoImportacao.value.split('-');

            const idUsuario = localStorage.getItem("idusuario");
            const formData = new FormData();
            const authToken = localStorage.getItem('adminToken');

            formData.append('file', file);
            formData.append('idusuario', idUsuario);
            formData.append('mes', mes);
            formData.append('ano', ano);

            setIsFetchingDataImportacao(true);

            const response = await post('/admin/importarquadrovendedores', formData, authToken);

            setIsFetchingDataImportacao(false);

            if (response.Sucesso) {
                setNotifier(true, response.Mensagem);
            } else {
                setNotifier(false, response.Mensagem);

            }
            limparInput();
        } catch (error) {
            setNotifier(false, 'Erro durante a importação!');
            console.error('Erro durante a importação:', error);
        }
    }

    function baixarExemploCSV() {
        const link = document.createElement('a');
        link.href = `${process.env.PUBLIC_URL}/exemploQuadroVendedores.csv`;
        link.download = 'exemploQuadroVendedores.csv'; // Nome do arquivo para download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function limparInput() {
        setFile(null);
        inputRef.current.value = null;
        setValorBaseCSVFileName(undefined);
    }

    const optionsMeses = () => {
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();

        const options = [];

        const maximoMesesFiltro = 2;
        for (let i = 0; i < maximoMesesFiltro; i++) {
            let mes = mesAtual - i;
            let ano = anoAtual;

            if (mes <= 0) {
                mes += 12;
                ano -= 1;
            }

            const mesLabel = meses[mes - 1]; // Subtrai 1 para compensar o índice baseado em zero
            const optionValue = `${mes}-${ano}`;
            const optionLabel = `${mesLabel}/${ano}`;
            options.unshift({ value: optionValue, label: optionLabel });
        }

        return options;
    }

    const handleChangeMesAnoImportacao = (selectedOption) => {
        setMesAnoImportacao(selectedOption);
        setDisabledImportacao(false);
    };

    return <>
        <AdminSection
            etapa={1} titulo={'Selecione os filtros'}
        >
            <div className='admin-filtros-dividos p-8'>
                <div className='admin-filtros-left'>
                    <div>
                        <label style={{ whiteSpace: 'nowrap' }} htmlFor="mes">Selecione o indicador</label>
                        <Select
                            name="periodo"
                            id="periodo"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={mesAnoImportacao}
                            onChange={handleChangeMesAnoImportacao}
                            options={optionsMeses()}
                            isClearable={false}
                            isSearchable={false}
                            placeholder="Selecione o mês"
                        />
                    </div>
                </div>
            </div>
        </AdminSection>

        <AdminSection
            etapa={2} titulo={'Importar Índices'} disabled={disabledImportacao}
        >

            <div className='p-8' style={{ paddingBottom: "16px" }}>
                <div className="texto-csv">
                    <span className="bold-text">Importe seu arquivo clicando no botão abaixo</span>
                    <div className="normal-text">O arquivo deve ser em formato CSV(Separado por virgulas).</div>
                </div>

                <div className='importar-csv'>
                    <label htmlFor="file_input" className="btn-label">Importar CSV</label>
                    <input type="file" accept='.csv' ref={inputRef} name='file_input' id="file_input" onChange={(e) => {
                        setValorBaseCSVFileName(e.target.files[0].name);
                        setFile(e.target.files[0]);
                    }} />
                    <label className='muda-nome'>{valorBaseCSVFileName === undefined ? '' : valorBaseCSVFileName}</label>
                </div>
            </div>

            <div className='animal-valorBase-buttons' style={{ textAlign: "center", padding: "0px" }}>
                <button
                    className='animal-refresh-btn'
                    onClick={limparInput}>Cancelar
                </button>
            </div>
            <div className="button-container">
                <button type="button" className='download-btn' onClick={baixarExemploCSV}> <DownloadIcon
                    style={{ width: '25px', height: '25px', marginRight: '10px' }} /> Exportar modelo</button>

                <button type="button" className="animal-save-btn" onClick={importarQuadroReal}>
                    {isFetchingDataImportacao ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <TailSpin color="#ffffff" height={20} width={39} />
                        </div>
                    ) : (
                        "Enviar CSV"
                    )}
                </button>
            </div>

        </AdminSection>

    </>
}
